import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { JourneyContext } from "../../context/journeyContext"
import { getValueFromJourney } from "../../services/helperFunctions"
import { RepeatableContext } from "../../context/repeatableContext"
import { lineCapital } from "../../../shared/functions"

const radioCardFormControlKey = [
  "CPCustomizePlanQuestionOne",
  "iSelect360CPCustomizePlanQuestionOne",
  "question",
  "CPCustomizePlanQuestionFour",
]

const tabFormControlKey = ["question"]
const carouselFormControlKey = ["CPCustomizePlanQuestionOne", "iSelect360CPCustomizePlanQuestionOne"]

export default function RepeatableComponentTextSimpleRadioGroup(props) {
  const [activeTab, setActiveTab] = useState(props.data.radioComponent[0].name)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [repeatableState,setRepeatableState] = useContext(RepeatableContext)
  const [showRender, setShowRender] = useState(false)

  let arr = {}

  useEffect(() => {
    if (!sectionState.sectionData[props.data.formControlKey]?.[props.index]) {
      props.data.radioComponent.map(element => {
        if (element.checked) {
          let temp
          if (sectionState.sectionData[props.data.formControlKey]) {
            let temp1 = sectionState.sectionData[props.data.formControlKey]
            temp1[props.index] = element.value;
            temp = temp1
          }else{
            let temp1 = []
            temp1[props.index] = element.value
            temp = temp1
          }
          if (sectionState.sectionId === props.sectionId) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: temp,
                },
              }
            })
          } else {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: props.sectionId,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: temp,
                },
              }
            })
          }
        }
      })
    }
    setShowRender(true)
  }, [])

  useEffect(() => {
    if(sectionState.sectionData?.["currentAddressSameasLA"] && sectionState.sectionData?.["currentAddressSameasLA"][props.index]  && props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"){
      autoFillAndFreezeAddress({value: sectionState.sectionData?.["currentAddressSameasLA"][props.index]})
    }
  }, [sectionState.sectionData?.["currentAddressSameasLA"] && sectionState.sectionData?.["currentAddressSameasLA"][props.index]])

  const autoFillAndFreezeAddress = (target) => {
    if (props.data.formControlKey === "currentAddressSameasLA") {
      let addressLine1Value
      let addressLine2Value
      let addressLine3Value
      let countryValue
      let pincodeValue
      let stateValue
      let cityValue
      let otherCityValue
      if(target.value === "Y"){
        addressLine1Value = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.addressLineOne"]
        addressLine2Value = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.addressLineTwo"]
        addressLine3Value = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.addressLineThree"]
        countryValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.currentCountryofResidence"]
        pincodeValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.pincode"]
        stateValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.state"]
        cityValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.city"]
        otherCityValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.commCity"]
      }else{
        addressLine1Value = ""
        addressLine2Value = ""
        addressLine3Value = ""
        countryValue = ""
        pincodeValue = ""
        stateValue = ""
        cityValue = ""
        otherCityValue = ""
      }
      
      let temp = JSON.parse(JSON.stringify(repeatableState["proposalFormNomineeDetails"]))
      console.log(temp, "before")
      let nominee = JSON.parse(JSON.stringify(temp[props.index]))
      
      let getStateValueAndDisable = (formControlKeyToSet, valueToSet, elseCaseValue, indexToFreeze) => {
        let tempState
        if(valueToSet){
          nominee.components[indexToFreeze]["disabled"] = true
        }else{
          nominee.components[indexToFreeze]["disabled"] = false
        }
        if (sectionState.sectionData[formControlKeyToSet]) {
          let temp1 = sectionState.sectionData[formControlKeyToSet]
          if (valueToSet) {
            temp1[props.index] = valueToSet
          } else {
            temp1[props.index] = elseCaseValue
          }
          tempState = temp1
        } else {
          let temp1 = []
          if (valueToSet) {
            temp1[props.index] = valueToSet
          } else {
            temp1[props.index] = elseCaseValue
          }
          tempState = temp1
        }
        return tempState
      }

      let addressLine1StateValue  = getStateValueAndDisable("address1nominee", addressLine1Value, "", 9)
      let addressLine2StateValue  = getStateValueAndDisable("address2nominee", addressLine2Value, "", 10)
      let addressLine3StateValue  = getStateValueAndDisable("address3nominee", addressLine3Value, "", 11)
      let countryStateValue  = getStateValueAndDisable("nomineeCountry", countryValue, "IN", 12)
      let pincodeStateValue  = getStateValueAndDisable("nomineePincode", pincodeValue, "", 13)
      let stateStateValue  = getStateValueAndDisable("stateNominee", stateValue, "", 14)
      let cityStateValue  = getStateValueAndDisable("cityNominee", cityValue, "", 15)
      let otherCityStateValue  = getStateValueAndDisable("cityTextNominee", otherCityValue, "", 16)

      let pincodeTypeChange = (indexToFreeze, isStrOrNum) => {
        if(isStrOrNum === "toStr"){
          nominee.components[indexToFreeze]["min_len"] = 3
          nominee.components[indexToFreeze]["max_length"] = 9
          nominee.components[indexToFreeze]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
          nominee.components[indexToFreeze]["min_len_error"] = "N0010"
          nominee.components[indexToFreeze]["max_len_error"] = "M0018"
          nominee.components[indexToFreeze]["regexError"] = "E256"
          nominee.components[indexToFreeze]["__typename"] = "ComponentCmpTagTextString"
        }else{
          nominee.components[indexToFreeze]["min_len"] = 6
          nominee.components[indexToFreeze]["regex"] = null
          nominee.components[indexToFreeze]["min_len_error"] = "N0002"
          nominee.components[indexToFreeze]["max_len_error"] = "M0002"
          nominee.components[indexToFreeze]["regexError"] = null
          nominee.components[indexToFreeze]["__typename"] = "ComponentCmpTagNumber"
        }
      }

      if(countryValue === "IN"){
        pincodeTypeChange(13, "toNum")
      }else{
        pincodeTypeChange(13, "toStr")
      }

      
      setSectionState(prev => {
        return ({
          ...prev,
          sectionData: {
            ...prev.sectionData,
            ["address1nominee"]: addressLine1StateValue,
            ["address2nominee"]: addressLine2StateValue,
            ["address3nominee"]: addressLine3StateValue,
            ["nomineeCountry"]: countryStateValue,
            ["nomineePincode"]: pincodeStateValue,
            ["stateNominee"]: stateStateValue,
            ["cityNominee"]: cityStateValue,
            ["cityTextNominee"]: otherCityStateValue
          }
        })
      })
      temp[props.index] = nominee
      console.log(temp, "after")
      setRepeatableState(prev => {
        return ({
          ...prev,
          ["proposalFormNomineeDetails"]: temp
        })
      })
    }
  }

  const createCardSet = () => {
    let cardContainers = document.querySelectorAll(".radio-card-container")

    cardContainers.forEach(cardContainer => {
      cardContainer.querySelectorAll("[data-active-class]").forEach(el => {
        let dataActiveClass = el.getAttribute("data-active-class")
        if (arr[dataActiveClass]) {
          arr[dataActiveClass] = [...arr[dataActiveClass], el]
        } else {
          arr[dataActiveClass] = [el]
        }
      })
    })
  }
  createCardSet()

  const handleActiveTab = ({ target }, value) => {
    if (target.getAttribute("data-active-tab")) {
      Array.from(target.parentElement.parentElement.children).forEach(el => {
        el.classList.remove("active-tab")
      })
      target.parentElement.classList.add("active-tab")
      setActiveTab(value)
    }
  }

  const handleChange = ({ target }) => {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = target.value;
        temp = temp1
      }else{
        let temp1 = []
        temp1[props.index] = target.value
        temp = temp1
      }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
      }
    })

    // if (target.value) {
    //   console.log(target.value)
    //   // console.log(target.value);
    //   // smoke-white-clr
    //   // console.log(target.parentElement.parentElement.parentElement)

    //   // radio-cards by Id
    //   let currentRadio = document
    //     .getElementById(target.value)
    //     .querySelector("[data-active-class]")
    //   console.log(currentRadio)
    //   // let parent = currentRadio.parentElement.querySelectorAll(".radio-card")

    //   // removing other active class
    //   let radios = arr[currentRadio.getAttribute("data-active-class")]
    //   radios?.forEach(radio => {
    //     radio.classList.remove("active")
    //   })

    //   // activate radio Radio
    //   currentRadio.classList.add("active")
    // }

    console.log(sectionState, "section state")
    // console.log(conditionState, "condition state")
  }
  return (
    showRender && (
    <>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }

        .radio-tab p{
          margin:0;
          
        }


        .active-tab{
          background-color: ${props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }
        
        `}
      </style>
      {radioCardFormControlKey.includes(props.data.formControlKey) ? (
        <>
          <p className="text-left plan-heading new-heading-font">
          {(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
          </p>

          {carouselFormControlKey.includes(props.data.formControlKey) ? (
            <div
              items={2}
              autoPlay={true}
              className="row radio-card-container "
              startPosition={1}
            >
              {props.data.radioComponent.map((element, i) => {
                return (
                  <div
                    className={`radio-card ${element.class}`}
                    aria-hidden="true"
                    key={i}
                    name={element.name}
                    id={element.value}
                    checked={
                      sectionState.sectionData[props.data.formControlKey]
                        ? sectionState.sectionData[
                            props.data.formControlKey
                          ] === element.value
                        : element.checked
                    }
                    onClick={e =>
                      handleChange({ target: { value: element.value } })
                    }
                  >
                    <div dangerouslySetInnerHTML={{ __html: element.html }} />
                  </div>
                )
              })}
            </div>
          ) : (
            // <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
            //   <div className="carousel-inner row radio-card-container ">
            //   {props.data.radioComponent.map((element, i) => {
            //     return (
            //       <div
            //         className={`carousel-item active radio-card ${element.class}`}
            //         key={i}
            //         name={element.name}
            //         id={element.value}
            //         checked={
            //           sectionState.sectionData[props.data.formControlKey]
            //             ? sectionState.sectionData[
            //                 props.data.formControlKey
            //               ] === element.value
            //             : element.checked
            //         }
            //         onClick={e =>
            //           handleChange({ target: { value: element.value } })
            //         }
            //       >
            //         <div dangerouslySetInnerHTML={{ __html: element.html }} />
            //       </div>
            //     )
            //   })}
            //   </div>
            //   <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            //     <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            //     <span class="sr-only">Previous</span>
            //   </a>
            //   <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            //     <span class="carousel-control-next-icon" aria-hidden="true"></span>
            //     <span class="sr-only">Next</span>
            //   </a>
            // </div>

            <div className="row radio-card-container">
              {tabFormControlKey.includes(props.data.formControlKey) ? (
                <div className="radio-tab hidden-lg hidden-md hidden-sm ">
                  {props.data.radioComponent.map((el, i) => {
                    if (el.label) {
                      return (
                        <div
                          className={`${
                            props.data.radioComponent[0].name == el.name
                              ? "active-tab"
                              : ""
                          }`}
                          aria-hidden="true"
                        >
                          <p
                            data-active-tab={el.value}
                            aria-hidden="true"
                            onClick={e => handleActiveTab(e, el.name)}
                            className="text-center"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {lineCapital(getValueFromJourney(
          journeyState.lookup.label,
          el.label
        )) || el.label}
                          </p>
                        </div>
                      )
                    }
                  })}
                </div>
              ) : null}
              {props.data.radioComponent.map((element, i) => {
                return (
                  <div
                    className={`radio-card ${element.class}`}
                    aria-hidden="true"
                    key={i}
                    name={element.name}
                    id={element.value}
                    checked={
                      sectionState.sectionData[props.data.formControlKey]
                        ? sectionState.sectionData[
                            props.data.formControlKey
                          ] === element.value
                        : element.checked
                    }
                    onClick={e =>
                      handleChange({ target: { value: element.value } })
                    }
                  >
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <p className="card-label text-left plan-heading new-heading-font hidden-xs">
                        {lineCapital(getValueFromJourney(
                            journeyState.lookup.label,
                            element.label
                          )) || element.label}
                      </p>
                    ) : null}
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: element.html }}
                        className={activeTab == element.name ? "" : "hidden-xs"}
                      />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: element.html }} />
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="form-group">
            <div className="radio-section-design">
              {/* <p>{props.data.label}</p> */}
              <p>{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</p>
            </div>
            {props.data.radioComponent.map((element, i) => {
              return (
                <div className="radio-line radio-design" key={i}>
                  <label className="customradio">
                    <span className="radiotextsty inp-label">{lineCapital(getValueFromJourney(
                                                                      journeyState.lookup.label,
                                                                      element.label
                                                                    )) || element.label}</span>
                    <input
                      type={element.type}
                      name={element.name + props.index}
                      id={element.value}
                      value={element.value}
                      checked={
                        (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
                          ? sectionState.sectionData[
                              props.data.formControlKey
                            ][props.index] === element.value
                          : element.checked
                      }
                      onChange={handleChange}
                    />
                    <span className="provider checkmark" tabIndex="0"></span>
                  </label>
                </div>
              )
            })}
          </div>
        </>
      )}
    </>
    )
  )
}
